class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onProductSearchSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  onProductSearchSubmit(event) {
    const form = this.input.form;
    form.querySelectorAll('[data-avp-search-filter]').forEach((element) => element.remove());
    if (event.defaultPrevented || !this.input.value.trim()) return;

    const key = this.input.value.trim().normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLocaleLowerCase('de-DE').replace(/ß/g, 'ss').replace(/[\s-]+/g, '');
    const categoryKey = key
      .replace(/^(personalisierte|personalisierter|personalisiertes)/, '')
      .replace(/(mitname|mitnamen|personalisiert|personalisierbar)$/, '');
    const canonicalQuery = {
      blattkissen: 'Blattkissen',
      blatkissen: 'Blattkissen',
      suncatcher: 'Suncatcher',
      sonnenfanger: 'Suncatcher',
      sonnenfaenger: 'Suncatcher',
      lichtfanger: 'Suncatcher',
      lichtfaenger: 'Suncatcher',
      haarklammer: 'Haarklammer',
      haarklammern: 'Haarklammer',
      haarklemme: 'Haarklammer',
      haarklemmen: 'Haarklammer',
      rechenkette: 'Rechenkette',
      rechenketten: 'Rechenkette',
      kindergartentute: 'Kindergartentüte',
      kindergartentuete: 'Kindergartentüte',
      kindergartentuten: 'Kindergartentüte',
      kindergartentueten: 'Kindergartentüte',
      kitatute: 'Kindergartentüte',
      kitatuete: 'Kindergartentüte',
      kitatuten: 'Kindergartentüte',
      kitatueten: 'Kindergartentüte',
      kigatute: 'Kindergartentüte',
      kigatuete: 'Kindergartentüte',
      kigatuten: 'Kindergartentüte',
      kigatueten: 'Kindergartentüte',
      schultute: 'Schultüte',
      schultuete: 'Schultüte',
      schultuten: 'Schultüte',
      schultueten: 'Schultüte',
      zuckertute: 'Schultüte',
      zuckertuete: 'Schultüte',
      zuckertuten: 'Schultüte',
      zuckertueten: 'Schultüte',
      kulturbeutel: 'Kulturbeutel',
      kosmetiktasche: 'Kosmetiktasche',
      waschbeutel: 'Kulturbeutel',
      taschchen: 'Täschchen',
      taeschchen: 'Täschchen',
      turnbeutel: 'Turnbeutel',
      sportbeutel: 'Turnbeutel',
      gymbag: 'Turnbeutel',
      wimpelkette: 'Wimpelkette',
      wimpelketten: 'Wimpelkette',
      blattergirlande: 'Blättergirlande',
      blaettergirlande: 'Blättergirlande',
      blattergirlanden: 'Blättergirlande',
      blaettergirlanden: 'Blättergirlande',
      sterngirlande: 'Sterngirlande',
      sterngirlanden: 'Sterngirlande',
      stoffstern: 'Sterngirlande',
      stoffsterne: 'Sterngirlande',
      musselinsterne: 'Sterngirlande',
      schlusselanhanger: 'Schlüsselanhänger',
      schluesselanhaenger: 'Schlüsselanhänger',
      kinderwagenanhanger: 'Kinderwagenanhänger',
      kinderwagenanhaenger: 'Kinderwagenanhänger',
      schnullerkette: 'Schnullerkette',
      schnullerketten: 'Schnullerkette',
    }[categoryKey];
    const productTypes = {
      blattkissen: ['Blattkissen'],
      blatkissen: ['Blattkissen'],
      suncatcher: ['Suncatcher'],
      sonnenfanger: ['Suncatcher'],
      sonnenfaenger: ['Suncatcher'],
      lichtfanger: ['Suncatcher'],
      lichtfaenger: ['Suncatcher'],
      haarklammer: ['Haarklammer'],
      haarklammern: ['Haarklammer'],
      haarklemme: ['Haarklammer'],
      haarklemmen: ['Haarklammer'],
      rechenkette: ['Rechenkette'],
      rechenketten: ['Rechenkette'],
      kindergartentute: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kindergartentuete: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kindergartentuten: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kindergartentueten: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kitatute: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kitatuete: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kitatuten: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kitatueten: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kigatute: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kigatuete: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kigatuten: ['Kindergartentüte', 'Kindergartenstart-Set'],
      kigatueten: ['Kindergartentüte', 'Kindergartenstart-Set'],
      schultute: ['Schultüte'],
      schultuete: ['Schultüte'],
      schultuten: ['Schultüte'],
      schultueten: ['Schultüte'],
      zuckertute: ['Schultüte'],
      zuckertuete: ['Schultüte'],
      zuckertuten: ['Schultüte'],
      zuckertueten: ['Schultüte'],
      kulturbeutel: ['Kulturbeutel', 'Kosmetiktasche', 'Täschchen', 'Kindergartenstart-Set'],
      kosmetiktasche: ['Kosmetiktasche', 'Kulturbeutel', 'Täschchen'],
      waschbeutel: ['Kulturbeutel', 'Kosmetiktasche'],
      taschchen: ['Täschchen', 'Kosmetiktasche'],
      taeschchen: ['Täschchen', 'Kosmetiktasche'],
      turnbeutel: ['Turnbeutel', 'Rucksack-Set', 'Kindergartenstart-Set'],
      sportbeutel: ['Turnbeutel', 'Rucksack-Set'],
      gymbag: ['Turnbeutel', 'Rucksack-Set'],
      wimpelkette: ['Wimpelkette', 'Mini-Wimpelkette'],
      wimpelketten: ['Wimpelkette', 'Mini-Wimpelkette'],
      blattergirlande: ['Blättergirlande'],
      blaettergirlande: ['Blättergirlande'],
      blattergirlanden: ['Blättergirlande'],
      blaettergirlanden: ['Blättergirlande'],
      sterngirlande: ['Sterngirlande'],
      sterngirlanden: ['Sterngirlande'],
      stoffstern: ['Sterngirlande'],
      stoffsterne: ['Sterngirlande'],
      musselinsterne: ['Sterngirlande'],
      schlusselanhanger: ['Schlüsselanhänger', 'Geschenkset'],
      schluesselanhaenger: ['Schlüsselanhänger', 'Geschenkset'],
      kinderwagenanhanger: ['Kinderwagenanhänger', 'Geschenkset'],
      kinderwagenanhaenger: ['Kinderwagenanhänger', 'Geschenkset'],
      schnullerkette: ['Schnullerkette', 'Geschenkset'],
      schnullerketten: ['Schnullerkette', 'Geschenkset'],
    }[categoryKey];

    if (!Array.isArray(productTypes)) return;
    if (canonicalQuery) this.input.value = canonicalQuery;
    productTypes.forEach((productType) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'filter.p.product_type';
      input.value = productType;
      input.setAttribute('data-avp-search-filter', '');
      form.appendChild(input);
    });
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
